// extracted by mini-css-extract-plugin
export default {"img":"Badge_img__X4XJC"};